import Button from 'src/components/Custom/Button/Button'
import CustomModal from 'src/components/Custom/Modal/CustomModal'

interface YesNoConfirmationModalProps {
  show: boolean
  content: string | React.JSX.Element
  positiveText?: string
  negativeText?: string
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  onConfirm: () => void
  onCancel: () => void
}

const YesNoConfirmationModal = ({
  show,
  content,
  setShowModal,
  onCancel,
  onConfirm,
  positiveText = 'Yes',
  negativeText = 'No',
}: YesNoConfirmationModalProps) => (
  <CustomModal setShowModal={setShowModal} showModal={show}>
    <div className="text-center sm:text-left">
      <span>{content}</span>
      <div className="mt-5 flex gap-5">
        <Button
          title={positiveText}
          customButtonClass={
            'bg-blue-600 w-full rounded-sm px-6 py-4 font-bold text-white hover:text-white'
          }
          onClick={onConfirm}
        />
        <Button
          title={negativeText}
          customButtonClass={
            'bg-red-600 w-full rounded-sm px-6 py-4 font-bold text-white hover:text-white'
          }
          onClick={onCancel}
        />
      </div>
    </div>
  </CustomModal>
)

export default YesNoConfirmationModal
